import React, { useState } from "react";
import { Modal } from "antd";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  YAxis,
  XAxis
} from "recharts";
import { VisualizationType } from "../../../consts/VisualizationType";
import { useInformationLookupsBreakdown } from "../../../hooks/StatisticsHooks";
import { NumberOfInformationLookupsByMonthVisualization } from "../NumberOfInformationLookupsByMonthVisualization/NumberOfInformationLookupsByMonthVisualization";
import { useBoolean } from "usehooks-ts";

/**
 * To draw the information lookups bar/pie charts
 */
export const InformationLookupsVisualization = ({ visualizationType, visualizationRef, startDate, endDate }) => {
  const { data } = useInformationLookupsBreakdown();
  const { value: modalVisible, setTrue: showModal, setFalse: hideModal } = useBoolean();
  const [modalIndex, setModalIndex] = useState();
  const colours = ["#1f77b4", "#ff7f0e", "#FFBB28"];

  const onBarChartClick = (index) => {
    setModalIndex(index);
    showModal();
  };

  let chart;
  switch (visualizationType) {
    case VisualizationType.PIE:
      chart = (
        <PieChart ref={visualizationRef} margin={{ top: 20 }}>
          <Legend verticalAlign="top" height={50} iconSize={30} />
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colours[index % colours.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      );
      break;
    case VisualizationType.BAR:
    default:
      chart = (
        <BarChart
          ref={visualizationRef}
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="value" fill="#8884d8" name="Number of Times">
            {data?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colours[index % 20]} onClick={() => onBarChartClick(index)} />
            ))}
          </Bar>
        </BarChart>
      );
      break;
  }

  return (
    <div style={{ backgroundColor: "white" }}>
      <ResponsiveContainer width="100%" height={610}>
        {chart}
      </ResponsiveContainer>
      <Modal visible={modalVisible} width={"100%"} footer={null} onCancel={hideModal}>
        <NumberOfInformationLookupsByMonthVisualization startDate={startDate} endDate={endDate} index={modalIndex} />
      </Modal>
    </div>
  );
};

// To calculate the position of where to put the label
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};
